import { useApiProblem } from '@/shared/api';
import { canAccess, ROLE_GROUPS, useAuth } from '@/shared/auth';
import { QuarantineHint } from './QuarantineHint';
import { RevisionHoldsUnavailable } from './RevisionHoldsUnavailable';
import { useRevisionHolds } from './useRevisionHolds';

/**
 * Der workspaceweite Einstieg in die Liste: die Hausübersicht zeigt nur ihr Objekt, und eine
 * Revision, die vor jeder Objekt-Zuordnung scheiterte, gehört zu keinem. Nur Verwaltung und
 * Mitarbeiter fragen überhaupt an — der Server lehnt alle anderen ohnehin ab. Die Zahl ist die
 * des Servers über alle sichtbaren Revisionen; konnte sie nicht geladen werden, steht das da,
 * statt dass der Hinweis wie „keine" einfach fehlt.
 */
export function BookingsQuarantineHint() {
  const allowed = canAccess(useAuth().user, ROLE_GROUPS.staff);
  const holds = useRevisionHolds(allowed);
  const problem = useApiProblem(holds.error);
  if (!allowed) return null;
  if (!holds.data && (holds.isError || holds.fetchStatus === 'paused')) {
    return (
      <RevisionHoldsUnavailable
        offline={!holds.isError}
        reason={problem?.detail}
        onRetry={() => void holds.refetch()}
      />
    );
  }
  return (
    <QuarantineHint
      quarantined={holds.data?.quarantinedTotal ?? 0}
      awaiting={holds.data?.awaitingTotal ?? 0}
      stale={holds.isError && !!holds.data}
    />
  );
}
